import type {
    Appearance as StripeElementsAppearance,
    CssFontSource,
    CustomFontSource
} from '@stripe/stripe-js';
import {
    useCdnResource
} from 'x1-base/composables';
import { useCssVar } from '@vueuse/core';
import { get as lo_get } from 'es-toolkit/compat';

export function useStripeElementsAppearance() {

    const $config = useRuntimeConfig();
    const useCdnResourceObj = useCdnResource();

    const opacityFocus = useCssVar('--v-focus-opacity');
    // const opacityBorder = useCssVar('--v-border-opacity');
    // const opacityEmphasis = useCssVar('--v-high-emphasis-opacity');
    const opacityDisabled = useCssVar('--v-disabled-opacity');

    const colorThemePrimary = useCssVar('--v-theme-primary');
    const colorThemeSecondary = useCssVar('--v-theme-secondary');
    const colorBorder = useCssVar('--v-border-color');

    const colorBackground = useCssVar('--v-theme-background');
    const colorOnBackground = useCssVar('--v-theme-on-background');
    const colorError = useCssVar('--v-theme-error');

    function getTheme(): { appearance: StripeElementsAppearance, fonts: Undefinable<Array<CssFontSource | CustomFontSource>> } {
        // TODO: Fix type
        const fontsConfigObj = lo_get($config, 'public.theme.stripe.fonts', null) as any;
        let fonts: Undefinable<Array<CssFontSource | CustomFontSource>>;
        let fontFamily: string | undefined;

        if (fontsConfigObj) {
            const mainFont = fontsConfigObj.mainFont.family;

            fontFamily = [
                mainFont,
                ...fontsConfigObj.secondaryFonts
            ].join(',');

            const fontsUrl: string = useCdnResourceObj.getResourceCdnUrl(fontsConfigObj.mainFont.url);

            fonts = [
                {
                    family: mainFont,
                    src: `url(${fontsUrl})`,
                    weight: '500'
                }
            ];
        }

        const appearance: StripeElementsAppearance = {
            theme: 'stripe',
            variables: {
                fontFamily,
                borderRadius: '4px'
            },
            rules: {

                '.PickerAction:hover': {
                    backgroundColor: `rgba(${colorThemeSecondary.value}, ${opacityFocus.value})`,
                },
                '.PickerAction': {
                    fontSize: '12px',
                    fontWeight: 'normal',
                    textTransform: 'uppercase',
                    color: `rgb(${colorThemeSecondary.value})`,
                    backgroundColor: `rgba(${colorThemeSecondary.value}, ${opacityFocus.value})`,
                    padding: '8px 12px 6px 12px',
                    letterSpacing: '1.0714px'
                },


                // '.Tab': {
                //     boxShadow: 'none',
                //     border: `1px solid rgba(${colorBorder.value}, ${opacityBorder.value})`
                // },
                // '.Tab:focus': {
                //     boxShadow: 'none',
                //     borderColor: `rgba(${colorBorder.value}, ${opacityBorder.value})`
                // },
                // '.Tab--selected': {
                //     boxShadow: 'none',
                //     color: `rgba(${colorBackground.value}, 1)`,
                //     backgroundColor: `rgb(${colorThemePrimary.value})`
                // },
                // '.Tab--selected:hover': {
                //     color: `rgba(${colorBackground.value}, 1)`
                // },
                // '.Tab--selected:focus': {
                //     boxShadow: 'none'
                // },
                // '.TabIcon--selected': {
                //     fill: `rgba(${colorBackground.value}, 1)`
                // },


                '.Label': {
                    color: `rgba(${colorOnBackground.value}, 1)`,
                    fontWeight: 'bold'
                },


                '.Input': {
                    boxShadow: 'none',
                    border: `1px solid rgba(${colorBorder.value}, ${opacityDisabled.value})`,
                    color: `rgb(${colorOnBackground.value})`,
                    backgroundColor: `rgb(${colorBackground.value})`,
                    fontWeight: 'normal'
                },
                '.Input:focus': {
                    border: `1px solid rgba(${colorBorder.value}, 1)`,
                    boxShadow: `0 0 0 1px rgb(${colorBorder.value})`
                },
                '.Input:hover': {
                    boxShadow: 'none',
                    border: `1px solid rgba(${colorBorder.value}, 1)`
                },


                '.Input.Input--invalid': {
                    color: `rgb(${colorError.value})`,
                    border: `1px solid rgba(${colorError.value}, 1)`,
                    boxShadow: 'none'
                },
                '.Input.Input--invalid:hover': {
                    color: `rgb(${colorError.value})`,
                    border: `1px solid rgba(${colorError.value}, 1)`,
                    boxShadow: `0 0 0 1px rgb(${colorError.value})`
                },
                '.Input.Input--invalid:focus': {
                    color: `rgb(${colorError.value})`,
                    border: `1px solid rgba(${colorError.value}, 1)`,
                    boxShadow: `0 0 0 1px rgb(${colorError.value})`
                },

                // NOTE: Not a valid selector
                // '.Input.Input--invalid:active': {
                //     color: `rgb(${colorError.value})`,
                //     border: `1px solid rgba(${colorError.value}, 1)`,
                //     boxShadow: `0 0 0 1px rgb(${colorError.value})`
                // },


                '.PickerItem--highlight': {
                    border: `1px solid rgb(${colorThemePrimary.value})`,
                    boxShadow: `0 0 0 1px rgb(${colorThemePrimary.value})`
                },


                '.Error': {
                    fontSize: '12px',
                    fontWeight: 'normal',
                    color: `rgb(${colorError.value})`,
                    paddingLeft: '1rem'
                }
            }
        };

        return {
            appearance,
            fonts
        };
    }

    return {
        getTheme
    };
}
